/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Target_Folder_HelpInputs */

const en_drastic_tech_target_folder_help = /** @type {(inputs: Drastic_Tech_Target_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a target location that is used for the final outputs.`)
};

const fr_drastic_tech_target_folder_help = /** @type {(inputs: Drastic_Tech_Target_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez un emplacement cible utilise pour les sorties finales.`)
};

const de_drastic_tech_target_folder_help = /** @type {(inputs: Drastic_Tech_Target_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie einen Zielort aus, der für die endgültigen Ausgaben verwendet wird.`)
};

const it_drastic_tech_target_folder_help = /** @type {(inputs: Drastic_Tech_Target_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezionare una posizione di destinazione da utilizzare per gli output finali.`)
};

const ru_drastic_tech_target_folder_help = /** @type {(inputs: Drastic_Tech_Target_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите целевое местоположение, которое будет использоваться для получения окончательных результатов.`)
};

const es_drastic_tech_target_folder_help = /** @type {(inputs: Drastic_Tech_Target_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione una ubicación de destino que se utilizará para los resultados finales.`)
};

const zh_cn2_drastic_tech_target_folder_help = /** @type {(inputs: Drastic_Tech_Target_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择最终输出的目标位置。`)
};

const ja_drastic_tech_target_folder_help = /** @type {(inputs: Drastic_Tech_Target_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終出力に使用するターゲットの場所を選択します。`)
};

const hi_drastic_tech_target_folder_help = /** @type {(inputs: Drastic_Tech_Target_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम आउटपुट के लिए उपयोग किए जाने वाले लक्ष्य स्थान का चयन करें।`)
};

const pt_pt2_drastic_tech_target_folder_help = /** @type {(inputs: Drastic_Tech_Target_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um local de destino que será usado para os resultados finais.`)
};

/**
* | output |
* | --- |
* | "Select a target location that is used for the final outputs." |
*
* @param {Drastic_Tech_Target_Folder_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_target_folder_help = /** @type {((inputs?: Drastic_Tech_Target_Folder_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Target_Folder_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_target_folder_help(inputs)
	if (locale === "de") return de_drastic_tech_target_folder_help(inputs)
	if (locale === "it") return it_drastic_tech_target_folder_help(inputs)
	if (locale === "ru") return ru_drastic_tech_target_folder_help(inputs)
	if (locale === "es") return es_drastic_tech_target_folder_help(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_target_folder_help(inputs)
	if (locale === "ja") return ja_drastic_tech_target_folder_help(inputs)
	if (locale === "hi") return hi_drastic_tech_target_folder_help(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_target_folder_help(inputs)
	return en_drastic_tech_target_folder_help(inputs)
});